// extracted by mini-css-extract-plugin
module.exports = {"loader_spinner":"_3VxzT7d5K-Zd","rotation":"_3m0BjOFV8viQ","loader":"_16k879RzodMo","loader__content":"jZmlMkvEwnD4"};